import axiosInstance from "../../../helpers/api";

export const getAllHomeworks = (body) => {
  return axiosInstance.get("/admin/homeworks", body);
};

export const editHomeworks = (formData) => {
  return axiosInstance.post(
    `/admin/homeworks/${formData.id}`,
    formData.formData
  );
};

export const createHomeworks = (formData) => {
  return axiosInstance.post("/admin/homeworks", formData);
};

export const deleteHomework = (id) => {
  return axiosInstance.delete(`/admin/homeworks/${id}`);
};

export const getHomeworkReportByChapter = (id) => {
  return axiosInstance.get(`/admin/student_homeworks/get_homework_report_per_chapter/${id}`);
};
